import React, { useState, useContext } from 'react';
import { AuthContext } from '../../../reducers/auth_reducers';
import { useHistory } from "react-router-dom";
import axios from 'axios';

import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';

import { authNotification } from '../../../components/notifications/fileupload_notification';
import CustomizedInputs from '../../../components/TextInput';

import { General, AuthModal, Button } from './Login.Style';

const Login = () => {
  const { dispatch } = useContext(AuthContext);
  const initialState = {
    email: "",
    password: "",
    isSubmitting: false,
    errorMessage: null
  };

  const [data, setData] = useState(initialState);
  let history = useHistory();

  const handleFormChange = event => {
      setData({
      ...data,
      [event.target.name]: event.target.value,
      errorMessage: null
    });
  };

  const handleFormSubmit = event => {
    event.preventDefault();
    setData({
      ...data,
      isSubmitting: true,
      errorMessage: null
    });
    
    let url = 'https://blooming-spire-64013.herokuapp.com/users/authenticate';
    axios.post(url, 
      { email: data.email, password: data.password},
      { withCredentials: true})
      .then(res => {
        if (res.data) {
            history.push("/dashboard", res.data.user);
          dispatch({
            type: "LOGIN",
            payload: res.data
          })
        }
      })
      .catch(error => {
        setData({
          ...data,
          isSubmitting: false,
          errorMessage: error.message || error.statusText
        });
      });
  };



  return (
    <General>
      <NotificationContainer />
      <AuthModal>
        <form 
        onSubmit={handleFormSubmit}
        style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}
        >
          <CustomizedInputs purpose={'Email'} type={'email'} name='email' handleFormChange={handleFormChange}/>
          <CustomizedInputs purpose={'Contraseña'} type={'password'} name='password' handleFormChange={handleFormChange}/>
          <Button auth disabled={data.isSubmitting}>
            {data.isSubmitting ? (
              "Cargando..."
              ) : (
                "Enviar"
                )}
          </Button>
          { data.errorMessage && 
            authNotification('error', 'Combinación de correo y contraseña incorrecta.')()
          }
        </form>
      </AuthModal>
    </General>
  );
}

export default Login;
